import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import Stack from '@mui/material/Stack';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import Iconify from 'src/components/iconify';

type Props = {
  onSearch: (value: string) => void;
};

export default function CandidatesTableToolbar({ onSearch }: Props) {
  const [input, setInput] = useState<string>('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      onSearch(value);
    }, 500),
    []
  );

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setInput(value);
    debouncedSearch(value);
  };

  const clearSearchText = () => {
    setInput('');
    debouncedSearch('');
  };

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{ xs: 'column', md: 'row' }}
      sx={{ p: 2.5, pr: { xs: 2.5, md: 1 } }}
    >
      <TextField
        fullWidth
        value={input}
        onChange={handleSearchChange}
        placeholder="Search by payer name, account number or bank..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          ),
          endAdornment:
            input.length > 0 ? (
              <InputAdornment position="end">
                <IconButton onClick={clearSearchText}>
                  <Iconify icon="eva:close-fill" color="text.disabled" />
                </IconButton>
              </InputAdornment>
            ) : null,
        }}
        inputProps={{ autoComplete: 'off' }}
      />
    </Stack>
  );
}
